<template>
    <nav aria-label="Page navigation" v-show="totalRecords > 0">
        <div class="d-flex justify-content-around flex-wrap flex-md-row flex-column align-items-center">
            <!-- Sección de Total Records paginatorBackend?.DataCount ?? totalRecords  -->
            <div class="p-2 text-center mb-3">
                <span class="font-weight-bold text-muted">Total Records</span>
                {{ totalRecords }}
            </div>
            <!-- Sección de Selector de Página backend-->            
            <div class="p-0 " v-bind:class=" screenSmall ? '': 'ml-5 text-right'"  v-if="paginatorBackend !== null && paginatorBackend !== undefined">
                <ul class="pagination justify-content-center">
                    <li class="page-item" v-if="paginatorBackend !== null && paginatorBackend !== undefined">
                        <select class="form-control form-control-sm"  v-on:change="handleBlockPageChange($event)" >
                            <option v-for="n in paginatorBackend?.TotalPages" :key="n" :value="n">
                               Block {{ n }}
                            </option>
                        </select>
                    </li>
                    <li class="page-item">
                        <select id="page-select" class="form-control form-control-sm" v-model.number="selectedPage" v-on:change="jumpToPage">
                            <option v-for="page in totalPagesArray" :key="page" :value="page">
                                Page {{ page }}
                            </option>
                        </select>
                    </li>
                </ul>
            </div>

            <!-- Sección de Paginación  del block-->
            <div class="p-0 " v-bind:class=" screenSmall ? '': 'mr-5 text-left'">
                <ul class="pagination pagination-sm justify-content-center">
                    <li class="page-item" v-if="paginatorBackend === null || paginatorBackend === undefined">
                        <select id="page-select" class="form-control form-control-sm" v-model.number="selectedPage" v-on:change="jumpToPage">
                            <option v-for="page in totalPagesArray" :key="page" :value="page">
                                Page {{ page }}
                            </option>
                        </select>
                    </li>
                    <!-- Botón de Página Anterior -->
                    <li class="page-item" :class="{ 'disabled': isPrevDisabled, 'active': currentPage === 1 }">
                        <a class="page-link text-primary" @click="prevPage">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </a>
                    </li>
                    <!-- Páginas visibles -->
                    <li class="page-item" v-for="page in visiblePages" :key="page"
                        :class="{ 'active': currentPage === page }">
                        <a class="page-link " @click="goToPage(page)">{{ page }}</a>
                    </li>
                    <!-- Botón de Página Siguiente -->
                    <li class="page-item" :class="{ 'disabled': isNextDisabled, 'active': currentPage === totalPagesArray.length }">
                        <a class="page-link text-primary" @click="nextPage">
                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Sección de Displayed Records -->
            <div class="p-2 text-center mb-3">
                <span class="font-weight-bold text-muted">Displayed from</span> {{ from }} <span class="font-weight-bold text-muted">to</span> {{ to }}
            </div>
        </div>
    </nav>
</template>

<script lang="ts" setup >
import { ref, computed,onBeforeUnmount,onMounted} from 'vue';
    interface PaginationProps {
        currentPage: number;
        totalPages: number;
        prevPage: () => void;
        nextPage: () => void;
        goToPage: (page: number) => void;
        visiblePages: number[];
        totalRecords: number;
        from: number;
        to: number;
        currentData?: string;
        paginatorBackend?: {
            DataCount?: number | null | undefined,
            TotalPages?: number | null | undefined,
            PageNumber?: number | null | undefined,
            PageSize?: number | null | undefined
        } | null | undefined;
        goToPageBackend?: (pageNumber: number,current:string) => void;
    }
    const props = defineProps<PaginationProps>();

    onBeforeUnmount(() => {
    window.removeEventListener('resize', updateWindowSize);
    });

    onMounted(() => {
        updateWindowSize();
        window.addEventListener('resize', updateWindowSize);
    });

    const screenSmall = ref(false);
    const updateWindowSize = () => {  screenSmall.value = window.innerWidth < 768; };
    const isPrevDisabled = computed(() => props.currentPage <= 1);
    const isNextDisabled = computed(() => props.currentPage >= props.totalPages);
    const selectedPage = ref(props.currentPage);

    const prevPage = () => {
        if (!isPrevDisabled.value) props.prevPage();
    };

    const nextPage = () => {
        if (!isNextDisabled.value) props.nextPage();
    };

    const totalPagesArray = computed(() => {
        return Array.from({ length: props.totalPages }, (_, i) => i + 1);
    });

    const jumpToPage = () => {
        if (selectedPage.value >= 1 && selectedPage.value <= props.totalPages) {
            props.goToPage(selectedPage.value);
        } else {
            alert(`Por favor, ingrese un número de página válido entre 1 y ${props.totalPages}`);
        }
    };

    const handleBlockPageChange = (event: any) => {
        const pageNumber: number = parseInt((event.target as HTMLSelectElement).value, 10);
        
        if (props.goToPageBackend) {
            props.goToPageBackend(pageNumber, props.currentData ?? '');
        } else {
            console.error("goToPageBackend no está definido");
        }
    };
</script>